"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var topCartId = "Sale_TopCart";
exports.topCartId = topCartId;
var CartFlag;
(function (CartFlag) {
    CartFlag[CartFlag["Parts"] = 0] = "Parts";
    CartFlag[CartFlag["Accessories"] = 1] = "Accessories";
    CartFlag[CartFlag["Services"] = 2] = "Services";
})(CartFlag || (CartFlag = {}));
exports.CartFlag = CartFlag;
var LoadingType;
(function (LoadingType) {
    LoadingType[LoadingType["MiniLoading"] = 0] = "MiniLoading";
    LoadingType[LoadingType["MaskLayer"] = 1] = "MaskLayer";
})(LoadingType || (LoadingType = {}));
exports.LoadingType = LoadingType;
function isMobileOrTable() {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
}
exports.isMobileOrTable = isMobileOrTable;
//The temporary plan will be deleted in the next MTP.
function operationDocument() {
    window["LoginNote"] = $($(".pro-detail .table")[0]).html();
    if ($("#" + topCartId).length === 0) {
        $("<div tabindex='0'></div>").attr("id", topCartId).appendTo("header>.navbar-first");
    }
    $(".cart-mask-bg").remove();
    $("#Cart_Error_Box").remove();
    $("#Cart_Login_Box").remove();
    $("#wps-shop-top-section").remove();
}
exports.operationDocument = operationDocument;
//Too cumbersome, and then rewrite this method.
function onListenClickErea() {
    try {
        var emements = $('a[data-menu-action]');
        for (var i = 0; i < emements.length; i++) {
            addEvent(emements[i], "click", function () { window["onHandleShowTopCart"](false); }, false);
        }
        if ($(".mobile-login").length > 0)
            addEvent($(".mobile-login")[0], "click", function () { window["onHandleShowTopCart"](false); }, false);
        if ($("#UserOption1").length > 0)
            addEvent($("#UserOption1")[0], "click", function () { window["onHandleShowTopCart"](false); }, false);
        if ($(".caps-track").length > 0)
            addEvent($(".caps-track")[0], "click", function () { window["onHandleShowTopCart"](false); }, false);
        if ($(".myaccount").length > 0)
            addEvent($(".myaccount")[0], "mouseover", function () { window["onHandleShowTopCart"](false); }, false);
        if ($(".selected-country").length > 0)
            addEvent($(".selected-country")[0], "click", function () { window["onHandleShowTopCart"](false); }, false);
        if ($(".selected-language").length > 0)
            addEvent($(".selected-language")[0], "click", function () { window["onHandleShowTopCart"](false); }, false);
        $(document).click(function (e) {
            var isContains = false;
            var nodes = getChildNodes($("#Sale_TopCart")[0]);
            nodes = nodes.concat(getChildNodes($(".wps-cart-box")[0]));
            for (var i = 0; i <= nodes.length; i++) {
                isContains = e.target == nodes[i];
                if (isContains)
                    break;
            }
            if (!isContains)
                window["onHandleShowTopCart"](false);
        });
    }
    catch (ex) { }
}
exports.onListenClickErea = onListenClickErea;
function addEvent(elm, evType, fn, useCapture) {
    if (elm.addEventListener)
        elm.addEventListener(evType, fn, useCapture);
    else if (elm.attachEvent)
        var r = elm.attachEvent('on' + evType, fn);
    else
        elm['on' + evType] = fn;
}
function getChildNodes(node) {
    try {
        var arr = [];
        var nodes = node.childNodes;
        for (var i = 0; i < nodes.length; i++) {
            var childNode = nodes[i];
            if (childNode.nodeType == 1) {
                arr.push(childNode);
                var temp = getChildNodes(childNode);
                arr = arr.concat(temp);
            }
        }
    }
    catch (ex) { }
    return arr;
}
exports.getChildNodes = getChildNodes;
function loadJS(name, url) {
    var isInclude = false;
    var es = document.getElementsByTagName('script');
    for (var i = 0; i < es.length; i++) {
        if (es[i]['src'].indexOf(name) != -1) {
            isInclude = true;
            break;
        }
    }
    if (!isInclude) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
    }
}
exports.loadJS = loadJS;
var InterfaceUtility = /** @class */ (function () {
    function InterfaceUtility() {
    }
    InterfaceUtility.getCartData = function (data, success, error, beforeSend) {
        $.ajax({
            type: "get",
            url: l.UrlUtility.getFullServicesPath("/Shop/GetCartData") + "?_=" + new Date().getTime() + "&&getFromCache=" + data.getFromCache + "&&cartFlag=" + data.cartFlag,
            beforeSend: beforeSend,
            success: success,
            error: error
        });
    };
    InterfaceUtility.addToCart = function (data, success, error, beforeSend) {
        $.ajax({
            type: "post",
            url: l.UrlUtility.getFullServicesPath("/Shop/AddToCart"),
            data: data,
            beforeSend: beforeSend,
            success: success,
            error: error
        });
    };
    InterfaceUtility.updateQuantity = function (data, success, error, beforeSend) {
        $.ajax({
            type: "post",
            url: l.UrlUtility.getFullServicesPath("/Shop/UpdataCart"),
            data: data,
            beforeSend: beforeSend,
            success: success,
            error: error
        });
    };
    InterfaceUtility.removeEntry = function (data, success, error, beforeSend) {
        $.ajax({
            type: "post",
            url: l.UrlUtility.getFullServicesPath("/Shop/RemoveToCart"),
            data: data,
            beforeSend: beforeSend,
            success: success,
            error: error
        });
    };
    return InterfaceUtility;
}());
exports.InterfaceUtility = InterfaceUtility;
